<mat-dialog-content>
  <div class="flex-container">
    <!-- LEFT COLUMN -->
    <div class="flex-item">
      @if(result.fileNumber) {
        <div class="flex-container">
          <div class="flex-item-2">{{ 'orders.fileNumber' | transloco }}</div>
          <div class="flex-item-3">{{ result.fileNumber }}</div>
        </div>
      }
      @if(result.baseRegistrationNumber && result.registrationNumber !== result.baseRegistrationNumber) {
        <div class="flex-container">
          <div class="flex-item-2">{{ 'orders.baseRegistration' | transloco }}</div>
          <div class="flex-item-3">{{ result.baseRegistrationNumber }}</div>
        </div>
      }
      @if(result.registrationNumber) {
        <div class="flex-container">
          <div class="flex-item-2">{{ 'orders.registrationNumber' | transloco }}</div>
          <div class="flex-item-3">{{ result.registrationNumber }}</div>
        </div>
      }
      @if((result.numberOfChanges ?? -1) > 0) {
        <div class="flex-container">
          <div class="flex-item-2">{{ 'orders.numberOfChanges' | transloco }}</div>
          <div class="flex-item-3">{{ result.numberOfChanges }}</div>
        </div>
      }
      @if(result.from) {
        <div class="flex-container">
          <div class="flex-item-2">{{ (result.isChangeType ? 'orders.changeDate' : 'orders.from') | transloco }}:</div>
          <div class="flex-item-3">{{ result.from | date: 'yyyy-MM-dd' }}</div>
        </div>
      }
      @if(result.to) {
        <div class="flex-container">
          <div class="flex-item-2">{{ 'orders.to' | transloco }}</div>
          <div class="flex-item-3">{{ result.to | date: 'yyyy-MM-dd' }}</div>
        </div>
      }
      @if(result.renewalTerm) {
        <div class="flex-container">
          <div class="flex-item-2">{{ 'orders.renewalTerm' | transloco }}</div>
          <div class="flex-item-3">{{ result.renewalTerm }}</div>
        </div>
      }
    </div>

    <!-- RIGHT COLUMN -->
    <div class="flex-item">
      @if(result.familyNumber ?? -1 > 0) {
        <div class="flex-container">
          <div class="flex-item-2">{{ 'orders.familyNumber' | transloco }}</div>
          <div class="flex-item-3">{{ result.familyNumber }}@if (result.familyResultNumber ?? -1 > 0) {
            <span>.{{
            result.familyResultNumber }}</span>
          }
        </div>
      </div>
    }
    @if(result.registrationType) {
      <div class="flex-container">
        <div class="flex-item-2">{{ 'orders.registrationType' | transloco }}</div>
        <div class="flex-item-3">{{ result.registrationType }}</div>
      </div>
    }
    @if(result.isChangeType && result.changeType) {
      <div class="flex-container">
        <div class="flex-item-2">{{ 'orders.changeType' | transloco }}</div>
        <div class="flex-item-3">{{ result.changeType }}</div>
      </div>
    }
    @if(result.isDischarged){
      <span>{{ 'orders.discharged' | transloco }}</span>
    } @else if(result.from && result.to) {
      <div class="flex-container">
        <div class="flex-item-2">{{ 'orders.registrationPeriod' | transloco }}</div>
        <div class="flex-item-3">{{ 'orders.nYears' | transloco: { n: getRegistrationPeriod() } }}</div>
      </div>
      <div class="flex-container">
        <div class="flex-item-2">{{ 'orders.remaining' | transloco }}</div>
        <div class="flex-item-3">{{ 'orders.nYears' | transloco: { n: getRemainingRegistrationPeriod() } }}</div>
      </div>
    } @else if(result.isInfiniteTerm) {
      <div class="flex-container">
        <div class="flex-item-2">{{ 'orders.remaining' | transloco }}</div>
        <div class="flex-item-3"><mat-icon>all_inclusive</mat-icon></div>
      </div>
    }
  </div>
</div>
@if(order.jurisdiction === 'BC' ||
  order.jurisdiction === 'SK') {
  <div class="flex-container">
    <div class="flex-item">
      <div class="flex-container-vertical-center">
        <div class="flex-item-2">{{ 'orders.trustIndenture2' | transloco }}</div>
        <div class="flex-item-3">
          <mat-checkbox disabled="true" [checked]="result.trustIndenture ?? false"></mat-checkbox>
        </div>
      </div>
    </div>
    <div class="flex-item"></div>
  </div>
} @else if(order.jurisdiction === 'MB') {
  <div class="flex-container mb-checkbox-section">
    <div class="flex-item">
      <div class="flex-container-vertical-center checkbox-row">
        <div class="flex-item-2">{{ 'orders.trustIndenture2' | transloco }}</div>
        <div class="flex-item-3">
          <mat-checkbox disabled="true" [checked]="result.trustIndenture ?? false"></mat-checkbox>
        </div>
      </div>
      <div class="flex-container-vertical-center checkbox-row">
        <div class="flex-item-2">{{ 'orders.perfectionInAnotherJurisdiction2' | transloco }}</div>
        <div class="flex-item-3">
          <mat-checkbox disabled="true"
          [checked]="result.perfectionInAnotherJurisdiction ?? false"></mat-checkbox>
        </div>
      </div>
    </div>
    <div class="flex-item">
      <div class="flex-container-vertical-center checkbox-row">
        <div class="flex-item-2">{{ 'orders.receiverAppointment2' | transloco }}</div>
        <div class="flex-item-3">
          <mat-checkbox disabled="true" [checked]="result.receiverAppointment ?? false"></mat-checkbox>
        </div>
      </div>
      <div class="flex-container-vertical-center checkbox-row">
        <div class="flex-item-2">{{ 'orders.purchaseMoneySecurityInterest2' | transloco }}</div>
        <div class="flex-item-3">
          <mat-checkbox disabled="true"
          [checked]="result.purchaseMoneySecurityInterest ?? false"></mat-checkbox>
        </div>
      </div>
    </div>
  </div>
} @else if(shouldShowOntarioClassificationsSection()) {
  <div class="flex-container">
    <div class="flex-item">
      <div class="flex-container-vertical-center checkbox-row">
        <div class="flex-item-2">{{ 'orders.consumerGoods' | transloco }}</div>
        <div class="flex-item-3">
          <mat-checkbox disabled="true" [checked]="result.consumerGoods ?? false"></mat-checkbox>
        </div>
      </div>
      <div class="flex-container-vertical-center checkbox-row">
        <div class="flex-item-2">{{ 'orders.inventory' | transloco }}</div>
        <div class="flex-item-3">
          <mat-checkbox disabled="true" [checked]="result.inventory ?? false"></mat-checkbox>
        </div>
      </div>
      <div class="flex-container-vertical-center checkbox-row">
        <div class="flex-item-2">{{ 'orders.equipment' | transloco }}</div>
        <div class="flex-item-3">
          <mat-checkbox disabled="true" [checked]="result.equipment ?? false"></mat-checkbox>
        </div>
      </div>
      <div class="flex-container">
        <div class="flex-item-2">{{ 'orders.maturityDate2' | transloco }}</div>
        <div class="flex-item-3">{{ result.maturityDate | date: 'yyyy-MM-dd' }}</div>
      </div>
      <div class="flex-container">
        <div class="flex-item-2">{{ 'orders.amount' | transloco }}</div>
        <div class="flex-item-3">{{ result.amount ? '$' : '' }}{{ result.amount ? result.amount : '' }}</div>
      </div>
    </div>
    <div class="flex-item">
      <div class="flex-container-vertical-center checkbox-row">
        <div class="flex-item-2">{{ 'orders.accounts' | transloco }}</div>
        <div class="flex-item-3">
          <mat-checkbox disabled="true" [checked]="result.accounts ?? false"></mat-checkbox>
        </div>
      </div>
      <div class="flex-container-vertical-center checkbox-row">
        <div class="flex-item-2">{{ 'orders.other' | transloco }}</div>
        <div class="flex-item-3">
          <mat-checkbox disabled="true" [checked]="result.other ?? false"></mat-checkbox>
        </div>
      </div>
      <div class="flex-container-vertical-center checkbox-row">
        <div class="flex-item-2">{{ 'orders.motorVehicleIncluded' | transloco }}</div>
        <div class="flex-item-3">
          <mat-checkbox disabled="true" [checked]="result.moterVehicle ?? false"></mat-checkbox>
        </div>
      </div>
      <div class="flex-container-vertical-center checkbox-row">
        <div class="flex-item-2">{{ 'orders.noFixedMaturityDate2' | transloco }}</div>
        <div class="flex-item-3">
          <mat-checkbox disabled="true" [checked]="result.noFixedMaturityDate ?? false"></mat-checkbox>
        </div>
      </div>
      <div class="flex-container-vertical-center checkbox-row">
        <div class="flex-item-2">{{ 'orders.cautionFiling2' | transloco }}</div>
        <div class="flex-item-3">
          <mat-checkbox disabled="true" [checked]="result.cautionFiling ?? false"></mat-checkbox>
        </div>
      </div>
    </div>
  </div>
}
<div class="flex-container">
  @if(hasDebtors()) {
    <div class="flex-item section-header-left">
      <div class="bold section-header">{{ 'orders.debtors' | transloco }}</div>
      <ul>
        @for(debtor of getDebtors(); track debtor.id) {
          <li><span [ngClass]="{ 'highlight': debtor.identifier.toUpperCase() === criteria.toUpperCase() }">{{ debtor.identifier }}</span></li>
        }
      </ul>
    </div>
  }
  @if(hasSecuredParties()) {
    <div class="flex-item">
      <div class="bold section-header">{{ 'common.labels.securedParties' | transloco }}</div>
      <ul>
        @for(securedParty of getSecuredParties(); track securedParty.id) {
          <li><span [ngClass]="{ 'highlight': securedParty.identifier.toUpperCase() === criteria.toUpperCase() }">{{ securedParty.identifier }}</span></li>
        }
      </ul>
    </div>
  }
</div>
<div class="flex-container">
  @if(hasTransferors()) {
    <div class="flex-item">
      <div class="bold section-header section-header-left">{{ 'orders.transferors' | transloco }}</div>
      <ul>
        @for(transferor of getTransferors(); track transferor.id) {
          <li><span [ngClass]="{ 'highlight': transferor.identifier.toUpperCase() === criteria.toUpperCase() }">{{ transferor.identifier }}</span></li>
        }
      </ul>
    </div>
  } @else if(hasTransferees()) {
    <div class="flex-item">
      <div class="bold section-header">{{ 'orders.transferees' | transloco }}</div>
      <ul>
        @for(transferee of getTransferees(); track transferee.id) {
          <li><span [ngClass]="{ 'highlight': transferee.identifier.toUpperCase() === criteria.toUpperCase() }">{{ transferee.identifier }}</span></li>
        }
      </ul>
    </div>
  }
</div>
<div class="flex-container">
  @if(hasAssignors()) {
    <div class="flex-item">
      <div class="bold section-header section-header-left">{{ 'common.labels.assignors' | transloco }}</div>
      <ul>
        @for(assignor of getAssignors(); track assignor.id) {
          <li><span [ngClass]="{ 'highlight': assignor.identifier.toUpperCase() === criteria.toUpperCase() }">{{ assignor.identifier }}</span></li>
        }
      </ul>
    </div>
  }
  @if(hasAssignees()) {
    <div class="flex-item">
      <div class="bold section-header">{{ 'common.labels.assignees' | transloco }}</div>
      <ul>
        @for(assignee of getAssignees(); track assignee.id) {
          <li><span [ngClass]="{ 'highlight': assignee.identifier.toUpperCase() === criteria.toUpperCase() }">{{ assignee.identifier }}</span></li>
        }
      </ul>
    </div>
  }
</div>
<div class="flex-container">
  @if(hasDealers()) {
    <div class="flex-item">
      <div class="bold section-header">{{ 'common.labels.dealers' | transloco }}</div>
      <ul>
        @for(dealer of getDealers(); track dealer.id) {
          <li><span [ngClass]="{ 'highlight': dealer.identifier.toUpperCase() === criteria.toUpperCase() }">{{ dealer.identifier }}</span></li>
        }
      </ul>
    </div>
  }
</div>
<div class="flex-container">
  @if(hasOtherParties()) {
    <div class="flex-item">
      <div class="bold section-header section-header-left">{{ 'orders.otherParties' | transloco }}</div>
      <ul>
        @for(other of getOtherParties(); track other.id) {
          <li><span [ngClass]="{ 'highlight': other.identifier.toUpperCase() === criteria.toUpperCase() }">{{ other.identifier }}</span></li>
        }
      </ul>
    </div>
  }
  @if(hasUndeterminedParties()) {
    <div class="flex-item">
      <div class="bold section-header">{{ 'orders.undeterminedParties' | transloco }}</div>
      <ul>
        @for(undetermined of getUndeterminedParties(); track undetermined.id) {
          <li><span [ngClass]="{ 'highlight': undetermined.identifier.toUpperCase() === criteria.toUpperCase() }">{{ undetermined.identifier }}</span></li>
        }
      </ul>
    </div>
  }
</div>
@if(hasSerialCollateral()) {
  <div class="bold section-header">{{ 'orders.serialNumbers' | transloco }}</div>
  @if(serialCollateralLeft.length > 0) {
    <div class="flex-container">
      <div class="flex-item">
        <ul>
          @for(serialNumber of serialCollateralLeft; track serialNumber.id) {
            <li><span [ngClass]="{ 'highlight': serialNumber.identifier.toUpperCase() === criteria.toUpperCase() }">{{ serialNumber.identifier }}</span></li>
          }
        </ul>
      </div>
      <div class="flex-item">
        <ul>
          @for(serialNumber of serialCollateralRight; track serialNumber.id) {
            <li><span [ngClass]="{ 'highlight': serialNumber.identifier.toUpperCase() === criteria.toUpperCase() }">{{ serialNumber.identifier }}</span></li>
          }
        </ul>
      </div>
    </div>
  } @else {
    <div class="flex-container-center padding">
      <span>{{ 'orders.noMatchingSerialNumbers' | transloco }}</span>
    </div>
  }
  @if(getSerialCollateral()!.length > 10) {
    <div class="flex-container-space-between flex-item">
      @if(this.serialCollateral.length > 40) {
        <mat-form-field class="flex-item form-field filter-section" appearance="outline">
          <mat-label>{{ 'orders.filterSerialNumbers' | transloco }}</mat-label>
          <input matInput type="text" (input)="onSerialNumberFilterChange($event)" data-testid="serial-number-filter">
        </mat-form-field>
      } @else {
        <div class="flex-item filter-section"></div>
      }
      <div class="flex-item pagination-section">
        <mat-paginator (page)="onPagingSerialCollateral($event)" showFirstLastButtons="true"
          [length]="serialCollateralLength" [pageIndex]="currentPageIndex" [pageSize]="10"
          [pageSizeOptions]="serialCollateralPageSizeOptions" [attr.aria-label]="'orders.selectSerialCollateralPage' | transloco">
        </mat-paginator>
      </div>
    </div>
  }
}
@if(hasGeneralCollateral() || hasGeneralCollateralFlags()) {
  <div class="padding-bottom">
    <div class="bold section-header">{{ 'common.labels.generalCollateral' | transloco }}</div>
    @if(hasGeneralCollateralFlags()) {
      <div class="general-collateral-flags">
        <div class="flex-container-vertical-center">
          <div class="flex-item-2">{{ 'orders.allOfTheDebtorSPresent' | transloco }}</div>
          <div class="flex-item-3">
            <mat-checkbox disabled="true" [checked]="result.securityInterest ?? false"></mat-checkbox>
          </div>
        </div>
        <div class="flex-container-vertical-center">
          <div class="flex-item-2">{{ 'orders.allOfTheDebtorSPresent2' | transloco }}</div>
          <div class="flex-item-3">
            <mat-checkbox disabled="true" [checked]="result.securityInterestExceptFor ?? false"></mat-checkbox>
          </div>
        </div>
      </div>
    }
    @for(block of getGeneralCollateral(); track block.id) {
      <div>
        @if(block.heading) {
          <div>{{ block.heading }}</div>
        }
        <div>{{ block.text }}</div>
      </div>
    }
  </div>
}
@if(hasAdditionalInformation()) {
  <div class="padding-bottom">
    <div class="bold section-header">{{ 'orders.additionalInformation' | transloco }}</div>
    @for(block of getAdditionalInformation(); track block.id) {
      <div>
        @if(block.heading) {
          <div>{{ block.heading }}</div>
        }
        <div>{{ block.text }}</div>
      </div>
    }
  </div>
}
@if(hasAmendmentDetails()) {
  <div class="padding-bottom">
    <div class="bold section-header">{{ 'orders.amendmentDetails' | transloco }}</div>
    @for(block of getAmendmentDetails(); track block.id) {
      <div>
        @if(block.heading) {
          <div>{{ block.heading }}</div>
        }
        <div>{{ block.text }}</div>
      </div>
    }
  </div>
}
</mat-dialog-content>
<mat-dialog-actions class="flex-container-right-align">
  <div class="spacer"></div>
  <button class="flex-item-fixed-size" mat-raised-button [mat-dialog-close]="true">{{ 'common.buttons.close' | transloco }}</button>
</mat-dialog-actions>